import * as actionTypes from './types/agent';
import { get } from '@/utillity/createAction';

export const getAgentProfile = params => get(actionTypes.GET_AGENT.INIT, params);

export default getAgentProfile;
